export const loadAppConfig = async () => {
  const configUrl =
    process.env.NODE_ENV === "development"
      ? "/config.development.json"
      : "/configs/config.production.json";

  try {
    const response = await fetch(configUrl);

    if (!response.ok) {
      throw new Error(`Erro ao carregar config de ${configUrl}`);
    }

    const config = await response.json();

    window.CONFIG = config;
  } catch (error) {
    console.error("Erro ao carregar configuração:", error);
  }
};
